/**
 * @fileoverview Provides utility functions to print documentation for Iterator CLI context types and watch modes. These functions output informative text describing different configuration options and their requirements for the Iterator development tool.
 */

import { info } from '@iterator/shared-node/util/logging'

export function printContextTypes() {
  info(`# allFiles
Include all files in the working directory in context. Respect .awignore and .gitignore

# embedding
Use embedding to search for relevant context. Requires index to have been built.

# lexical
Use lexical to search for relevant context. Requires index to have been built.

# agentic
Gives an LLM the option to look at the directory and loop reading files to find relevant context.
Requires ANTHROPIC_API_KEY

# documentation
LLM uses the @fileoverview jsdoc tag to select files to include in context. Requires \`awolf document\` to have been run and only works on JS/TS projects.
Requires GOOGLE_GENERATIVE_AI_API_KEY
`)
}

export function printWatchModes() {
  info(`# comment
LLM will observe file changes and output a description of what's being done.

# log
Store code change diffs to a file. This builds up a history of changes as you develop.

# multicomplete
Suggest changes to other parts of the file based on recent changes.
Requires FIREWORKS_API_KEY

# autocomplete
Suggest changes and continuations to the location currently being edited.
Requires FIREWORKS_API_KEY
`)
}
